module.exports = __webpack_public_path__ + "img/stock6.a4409d06.png";